<template>
  <v-dialog persistent max-width="1000" :value="show">
    <v-card class="pb-16">
      <v-card-title>
        Add game
      </v-card-title>
      <v-sheet class="px-10">
        <v-form>
          <v-row v-if="league && league.clubs">
            <v-col cols="6" v-for="side in ['home', 'away']" :key="side + 'side'">
              <v-sheet class="text-capitalize">
                {{ side }}
              </v-sheet>
              <v-select
                item-value="id"
                item-text="club_name"
                :items="league ? league.clubs : []"
                v-model="value[side + '_club_id']"
              >
                <template v-slot:item="{ item }">
                  <v-sheet class="d-flex flex-row align-center">
                    <v-img class="mr-5" max-width="30" max-height="30" contain :src="item.small_logo_url" />
                    <div class="text-overline">
                      {{ item.club_name }}
                    </div>
                  </v-sheet>
                </template>
                <template v-slot:selection="{ item }">
                  <v-sheet class="d-flex flex-row align-center">
                    <v-img class="mr-5" max-width="30" max-height="30" contain :src="item.small_logo_url" />
                    <div class="text-overline">
                      {{ item.club_name }}
                    </div>
                  </v-sheet>
                </template>
                <template v-slot:label>
                  Choose a team
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-for="side in ['home', 'away']"
              :key="side + '_side_score'"
              class="d-flex flex-row align-center justify-center" align-self="center" cols="6"
            >
              <v-btn
                fab
                text
                x-small
                @click="value[`score_${side}`] -= 1"
                :disabled="value[`score_${side}`] < 1"
              >
                <v-icon>mdi-minus</v-icon>
              </v-btn>
              <v-text-field
                solo
                hide-details
                v-model="value[`score_${side}`]"
                :label="`Score ${side}`"
                style="max-width: 60px; text-align: center !important;"
              />
              <v-btn
                fab
                text
                x-small
                @click="value[`score_${side}`] = Number(value[`score_${side}`]) + 1"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-sheet>Game starttime</v-sheet>
              <VueCtkDateTimePicker
                :value="value.starttime_unix ? value.starttime_unix.toString() : ''"
                @input="handleStarttimeInput"
                format="YYYY-MM-DD HH:mm"
                output-format="x"
              />
            </v-col>
            <v-col cols="6">
              <v-sheet>Game published</v-sheet>
              <VueCtkDateTimePicker
                :value="value.publishtime_unix ? value.publishtime_unix.toString() : ''"
                @input="value.publishtime_unix = $event"
                format="YYYY-MM-DD HH:mm"
                output-format="x" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                label="Video protocol"
                :items="['hls', 'mp4']"
                v-model="value.video_type"
                hide-details
              ></v-select>
            </v-col>
          </v-row>
          <v-select
            hide-details
            class="mt-4"
            item-text="season_name"
            item-value="id"
            label="Season"
            :loading="loading_seasons"
            :items="unarchived_and_current_seasons(value.season_id)"
            v-model="value.season_id"
          ></v-select>
          <v-select
            hide-details
            label="Done analysis state"
            class="mt-4"
            item-text="state_name"
            item-value="id"
            :loading="loading_seasons"
            :items="season.states"
            v-model="value.done_analysis_state"
          >
          </v-select>
          <v-text-field
            hide-details
            label="Season state *"
            class="mt-4"
            v-model="value.season_state"
          >
          </v-text-field>
          <v-row class="mt-2">
            <v-col cols="12">
              <v-text-field
                v-model="value.external_service_id"
                :label="external_service_id_name + ' id'"
              >
              </v-text-field>
              <v-text-field
                label="Video url"
                :value="value.video_url ? value.video_url : defaultVideoUrl"
                @input="value.video_url = $event"
              >

              </v-text-field>
              <v-text-field
                label="Video live url"
                :value="value.video_live_url ? value.video_live_url : defaultVideoLiveUrl"
                @input="value.video_live_url = $event"
              >

              </v-text-field>
              <v-text-field
                label="Second video url"
                v-model="value.second_video_url"
              >
              </v-text-field>
              <v-text-field
                label="Second video live url"
                v-model="value.second_video_live_url"
              >
              </v-text-field>
              <v-text-field
                label="Second video sync offset seconds"
                type="number"
                step="0.001"
                v-model.number="value.second_video_sync_offset_seconds"
                hint="Secondary video time minus primary video time. Leave empty until synced."
                persistent-hint
              >
              </v-text-field>
              <v-text-field
                clearable
                v-model="value.game_info"
                counter
                max-length="300"
                label="Game info"
              >
                <template v-slot:append-outer>
                  <v-icon color="blue">mdi-information-outline</v-icon>
                </template>
              </v-text-field>
              <v-text-field
                clearable
                v-model="value.game_error"
                counter
                max-length="300"
                label="Game error"
              >
                <template v-slot:append-outer>
                  <v-icon color="red">mdi-alert-outline</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="3"
            >
              <v-switch :input-value="true" v-model="value.will_be_analyzed" label="Will be analyzed"></v-switch>
            </v-col>
            <v-col
              cols="3"
            >
              <v-switch :input-value="false" v-model="value.shown_live" label="Shown live"></v-switch>
            </v-col>
          </v-row>
        </v-form>
        <v-sheet class="d-flex mt-10 justify-center">
          <v-btn outlined color="red" class="mb-10" @click="deletingGame = true">
            Delete game
          </v-btn>
        </v-sheet>
      </v-sheet>
      <confirmation-dialog
        :show="deletingGame"
        subText="Are you sure you want to delete the game? It cannot be reversed."
        text="Delete?"
        btnColor="red"
        btnText="Yes"
        @decline="deletingGame = false"
        @accept="deleteThisGame()"
      >
      </confirmation-dialog>
      <v-card-actions>
        <v-btn
          outlined
          @click="$emit('close')"
        >
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          color="primary"
          @click="$emit('save')"
        >
          Save game
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ConfirmationDialog from '../../../ConfirmationDialog.vue'
import { mapActions, mapGetters } from 'vuex'
import { cloudflareVideoLiveUrl, cloudflareVideoUrl } from '@/utils/video/hlsUrls'

export default {
  components: { ConfirmationDialog },
  props: ['show', 'value', 'league'],
  created() {
    this.initSeasons( this.$route.params.league_id )
      .then(() => {
        this.$nextTick(() => {
          if(!this.value.season_id) {
            if(this.seasons.length) this.value.season_id = this.seasons[0]['id']
          }

          if(!this.season.states) this.getSeasonStates({ id: this.season.id })
        })
      })
  },
  data: () => ({
    twoAndHalfHoursInMillis: 1000 * 60 * 60 * 2.5,
    deletingGame: false
  }),
  methods: {
    ...mapActions('admin', [
      'deleteGame',
      'initSeasons',
      'getSeasonStates'
    ]),
    ...mapActions('noti', [
      'info',
      'error'
    ]),
    handleStarttimeInput(e) {
      this.$emit('input', {...this.value, starttime_unix: Number(e), publishtime_unix: ( Number(e) + this.twoAndHalfHoursInMillis ).toString() });
    },
    deleteThisGame() {
      this.deleteGame(this.value.id)
        .then(() => {
          this.info('Peli poistettu')
          this.$emit('close')
          this.deletingGame = false
        })
        .catch(e => {
          this.error(e)
        })
    },
  },
  computed: {
    ...mapGetters('admin', [
      'unarchived_and_current_seasons',
      'loading_seasons',
      'leagueById',
      'seasons',
      'season_by_id'
    ]),
    season() {
      if(!this.value.season_id) return {}
      return this.season_by_id(this.value.season_id)
    },
    defaultVideoUrl() {
      return cloudflareVideoUrl(this.league?.default_video_url)
    },
    defaultVideoLiveUrl() {
      return cloudflareVideoLiveUrl(this.league?.default_video_live_url)
    },
    external_service_id_name() {
      const league = this.leagueById(this.$route.params.league_id)
      if(!league) return ''
      const config = league.configuration
      if(!config || typeof config !== 'string') return
      const parsed_config = JSON.parse(config)
      return parsed_config.external_sercive_id_name
    }
  }
}
</script>